import SecondContent from "./SecondContent";

export default SecondContent;
